import { render, staticRenderFns } from "./autocomp.vue?vue&type=template&id=dfe16aea&scoped=true&"
import script from "./autocomp.vue?vue&type=script&lang=js&"
export * from "./autocomp.vue?vue&type=script&lang=js&"
import style0 from "./autocomp.vue?vue&type=style&index=0&id=dfe16aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe16aea",
  null
  
)

export default component.exports